import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgPersonFill(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.75 9C8.75 4.99594 11.9959 1.75 16 1.75C20.0041 1.75 23.25 4.99594 23.25 9C23.25 13.0041 20.0041 16.25 16 16.25C11.9959 16.25 8.75 13.0041 8.75 9Z"
      />
      <path
        fill="currentColor"
        d="M28.9595 30.2501C29.3351 30.2501 29.6907 30.0812 29.9281 29.7902C30.1656 29.499 30.2591 29.1094 30.1825 28.7419L30.1803 28.7313L30.1734 28.6996C30.1676 28.6739 30.1596 28.6391 30.1491 28.5957C30.128 28.509 30.0969 28.388 30.054 28.2377C29.9682 27.9374 29.8345 27.518 29.6384 27.0192C29.2474 26.0246 28.6009 24.6962 27.5753 23.3629C25.4956 20.6594 21.8972 18 15.9595 18C10.0218 18 6.42332 20.6594 4.3437 23.3629C3.31806 24.6962 2.67158 26.0246 2.28054 27.0192C2.08444 27.518 1.95082 27.9374 1.865 28.2377C1.82205 28.388 1.79095 28.509 1.7699 28.5957C1.75938 28.6391 1.75135 28.6739 1.74561 28.6996C1.72882 28.7772 1.73498 28.7489 1.73498 28.7489C1.65951 29.1168 1.75347 29.4991 1.99086 29.7902C2.22825 30.0812 2.58391 30.2501 2.95948 30.2501L28.9595 30.2501Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPersonFill);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
